<p-button icon="bi bi-ai-sparkles-solo" severity="help" [text]="true" [rounded]="true" [pTooltip]="title"
    tooltipPosition="left" (onClick)="onClickToggle($event)"></p-button>

<p-popover #popover appendTo="body">
    <app-message class="block w-25rem max-w-full" severity="ai" icon="bi bi-ai-sparkles-solo" [title]="title"
        [titleNote]="titleNote" [primaryAction]="primaryAction" [secondaryActions]="secondaryActions"></app-message>
</p-popover>
